/* ==========================================================================
   WonderBuddy Divine Plush product page - REBUILD.

   Its own script, separate from the old page's wb-pdp.js and from the
   StoryBox Mini's wb-sbm.js, so the three can diverge without one breaking
   another. Both wb-pdp.js and this file load on the same page during the
   rebuild, so every hook here is named data-dvp-* and the init guard is its
   own flag.

   Six jobs: swap the main photo when a thumbnail is pressed, run the
   quantity stepper, add to cart without leaving the page, drive the mantra
   player, close sibling FAQs on browsers that lack native exclusive
   <details>, and run the looping video row. Everything is delegated from
   document, so sections re-rendered by the theme editor keep working with no
   re-binding.
   ========================================================================== */
(function () {
  if (window.wbDvpInit) { return; }
  window.wbDvpInit = true;

  function closest(el, sel) {
    return el && el.closest ? el.closest(sel) : null;
  }

  /* ---- gallery ---------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var btn = closest(e.target, '[data-dvp-thumbs] button');
    if (!btn) { return; }

    var strip = closest(btn, '[data-dvp-thumbs]');
    var section = closest(btn, '.wb-dvp');
    var main = section && section.querySelector('.dvp-main img');
    var img = btn.querySelector('img');
    if (!main || !img) { return; }

    var full = img.getAttribute('data-full');
    if (full) { main.src = full; }
    if (img.alt) { main.alt = img.alt; }

    strip.querySelectorAll('button').forEach(function (b) {
      b.classList.remove('is-active');
      b.setAttribute('aria-current', 'false');
    });
    btn.classList.add('is-active');
    btn.setAttribute('aria-current', 'true');
  });

  /* ---- quantity --------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var step = closest(e.target, '[data-dvp-step]');
    if (!step) { return; }

    var box = closest(step, '[data-dvp-qty]');
    var out = box && box.querySelector('[data-dvp-qty-value]');
    if (!out) { return; }

    var next = (parseInt(out.textContent, 10) || 1) + parseInt(step.getAttribute('data-dvp-step'), 10);
    if (next < 1) { next = 1; }
    if (next > 99) { next = 99; }
    out.textContent = next;
  });

  /* ---- add to cart ------------------------------------------------------ */
  document.addEventListener('click', function (e) {
    var add = closest(e.target, '[data-dvp-add]');
    if (!add) { return; }
    e.preventDefault();
    if (add.dataset.busy === '1') { return; }

    var id = add.getAttribute('data-variant-id');
    if (!id) { return; }

    /* The stepper lives in the same section; the sticky bar has none, so it
       falls back to one. */
    var section = closest(add, '.wb-dvp');
    var qtyEl = section && section.querySelector('[data-dvp-qty-value]');
    var qty = qtyEl ? (parseInt(qtyEl.textContent, 10) || 1) : 1;

    /* wb-cart.js missing (asset not created, or renamed) would
       otherwise throw here and leave the button greyed out forever.
       Fall back to the plain add so the shop still sells. */
    if (!window.wbCart) {
      console.error('[wb] wb-cart.js is not loaded - add-to-cart is running without the cart drawer. Create the asset "wb-cart.js".');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: qty }] })
      }).then(function () { window.location.href = '/cart'; });
      return;
    }
    window.wbCart.busy(add);

    /* wb-cart.js owns the request now. It fires the theme's own
       'shopify:cart:lines-update' before the round trip, which is what makes
       the header count move and the cart drawer slide open - this section used
       to add the item silently and leave the shopper looking at an unchanged
       cart. */
    window.wbCart.add({ id: id, quantity: qty, button: add })
      .then(function () {
        document.dispatchEvent(new CustomEvent('wb-dvp:added'));
        window.wbCart.flash(add, add.getAttribute('data-added') || 'Added');
      })
      .catch(function (error) {
        /* Never strand the button. The message is Shopify's own where there
           is one ("All 3 are in your cart"), which is more use than a silent
           bounce to the cart page. */
        window.wbCart.fail(add, error && error.message);
      });
  });

  /* ---- mantra list ------------------------------------------------------
     One <audio> per section, re-pointed rather than replaced. Reusing the
     element is what keeps the visitor's volume setting across tracks, and
     means starting a second mantra necessarily stops the first with no
     bookkeeping - eight tracks cost one element, not eight.

     The player's title is the ONLY thing the press rewrites, so the card can
     be restyled freely without touching this. */
  function auMark(section, btn, playing) {
    section.querySelectorAll('[data-dvp-au-track]').forEach(function (b) {
      b.classList.remove('is-current', 'is-playing');
      b.setAttribute('aria-pressed', 'false');
    });
    if (!btn) { return; }
    btn.classList.add('is-current');
    btn.setAttribute('aria-pressed', 'true');
    if (playing) { btn.classList.add('is-playing'); }
  }

  document.addEventListener('click', function (e) {
    var btn = closest(e.target, '[data-dvp-au-track]');
    if (!btn) { return; }

    var section = closest(btn, '.wb-dvp');
    var card = section && section.querySelector('[data-dvp-au]');
    var audio = card && card.querySelector('[data-dvp-au-audio]');
    var title = card && card.querySelector('[data-dvp-au-title]');
    var src = btn.getAttribute('data-src');
    if (!audio || !src) { return; }

    /* Pressing the mantra that is already sounding pauses it, rather than
       restarting it from zero - which is what a second press looks like it
       should do. Identity is the BUTTON, not the URL: two mantras that happen
       to share a file would otherwise toggle each other. */
    if (audio.wbOwner === btn && !audio.paused) {
      audio.pause();
      return;
    }

    if (title) { title.textContent = btn.getAttribute('data-title') || ''; }
    if (audio.getAttribute('src') !== src) { audio.setAttribute('src', src); }
    audio.wbOwner = btn;
    audio.currentTime = 0;
    auMark(section, btn, false);

    var playing = audio.play();
    if (playing && playing.then) {
      playing.catch(function () {
        /* Autoplay policy or a bad URL: leave the row selected but not
           marked as sounding, rather than animating over silence. */
        auMark(section, btn, false);
      });
    }

    if (!audio.dataset.bound) {
      audio.dataset.bound = '1';
      var section2 = section;

      audio.addEventListener('play', function () {
        auMark(section2, audio.wbOwner, true);
      });
      /* Deferred a tick: re-pointing a playing element fires a transient
         'pause' on the way to the next track, and acting on it immediately
         would wipe the incoming row's state. */
      audio.addEventListener('pause', function () {
        setTimeout(function () {
          if (audio.paused) { auMark(section2, audio.wbOwner, false); }
        }, 0);
      });

      audio.addEventListener('ended', function () {
        if (!audio.hasAttribute('data-advance')) {
          auMark(section2, audio.wbOwner, false);
          return;
        }
        var all = Array.prototype.slice.call(section2.querySelectorAll('[data-dvp-au-track]'));
        var i = all.indexOf(audio.wbOwner);
        /* Stop at the end of the list rather than looping back to the top:
           a mantra list restarting itself unprompted is not what a visitor
           who walked away from the page expects. */
        if (i > -1 && i + 1 < all.length) { all[i + 1].click(); }
        else { auMark(section2, audio.wbOwner, false); }
      });
    }
  });
  /* ---- FAQs -------------------------------------------------------------
     Fallback only. Modern browsers close the siblings themselves via the
     <details name> attribute the section writes; this covers the ones that
     do not support it yet. On browsers that DO, this runs and finds nothing
     left to close, which is why the two can sit on top of each other safely.

     Bound with capture: the 'toggle' event does not bubble, so a listener on
     document only sees it during the capture phase on the way down. */
  document.addEventListener('toggle', function (e) {
    var item = e.target;
    if (!item || !item.matches || !item.matches('[data-dvp-fq-item]')) { return; }
    if (!item.open) { return; }

    var list = closest(item, '[data-dvp-fq]');
    if (!list || !list.hasAttribute('data-single')) { return; }

    list.querySelectorAll('[data-dvp-fq-item]').forEach(function (other) {
      if (other !== item) { other.open = false; }
    });
  }, true);

  /* ---- looping video row ------------------------------------------------
     The markup holds ONE set of cards; the clones are added here.

     How many copies is computed, not fixed. The loop works by shifting the
     scroll position by exactly one period, which is only possible when the
     scrollable range is at least two periods wide - otherwise the shift lands
     out of bounds, the browser clamps it, and the row simply sticks at the
     end. A few short cards in a wide viewport fail that test, so a period is
     the set repeated however many times it takes to exceed the viewport.

     Layout: [k sets of clones][the real set + k-1 clone sets][k sets of
     clones]. Resting at scrollLeft = one period therefore shows the REAL
     cards, which is what the theme editor highlights and what screen readers
     reach - the clones are inert either side. */
  function buildLoop(wrap) {
    var row = wrap.querySelector('[data-dvp-rv-row]');
    if (!row || !wrap.hasAttribute('data-loop')) { return; }

    var originals = wrap._originals;
    if (!originals) {
      originals = Array.prototype.slice.call(row.children);
      wrap._originals = originals;
    }
    if (originals.length < 2) { return; }

    Array.prototype.slice.call(row.querySelectorAll('[data-clone]'))
      .forEach(function (n) { n.remove(); });

    /* Measured from the cards, NOT from row.scrollWidth: scrollWidth never
       reports less than clientWidth, so a set narrower than the viewport
       measures as the viewport and the copy count comes out far too low.
       Each set's width includes one trailing gap so the sets tile exactly. */
    var gap = parseFloat(getComputedStyle(row).columnGap) || 0;
    var setW = 0;
    originals.forEach(function (el) { setW += el.getBoundingClientRect().width; });
    setW += gap * originals.length;

    var view = row.clientWidth;
    if (!(setW > 0)) { return; }

    var k = Math.max(1, Math.ceil(view / setW));
    var period = setW * k;

    function cloneSet() {
      var frag = document.createDocumentFragment();
      originals.forEach(function (el) {
        var c = el.cloneNode(true);
        c.setAttribute('aria-hidden', 'true');
        c.setAttribute('data-clone', '');
        c.removeAttribute('id');
        Array.prototype.slice.call(c.querySelectorAll('button, a, video, iframe'))
          .forEach(function (b) { b.setAttribute('tabindex', '-1'); });
        frag.appendChild(c);
      });
      return frag;
    }

    var i;
    for (i = 0; i < k; i++) { row.insertBefore(cloneSet(), row.firstChild); }
    for (i = 0; i < 2 * k - 1; i++) { row.appendChild(cloneSet()); }

    wrap._period = period;
    var behavior = row.style.scrollBehavior;
    row.style.scrollBehavior = 'auto';
    row.scrollLeft = period;
    row.style.scrollBehavior = behavior;

    if (!wrap.dataset.loopBound) {
      wrap.dataset.loopBound = '1';
      var settling = false;
      var timer = null;

      function wrapNow() {
        var p = wrap._period;
        if (!p || settling) { return; }
        var x = row.scrollLeft;
        var shift = 0;
        if (x < p * 0.5) { shift = p; }
        else if (x > p * 1.5) { shift = -p; }
        if (!shift) { return; }
        var target = x + shift;
        if (target < 0 || target > row.scrollWidth - row.clientWidth) { return; }
        settling = true;
        var b = row.style.scrollBehavior;
        row.style.scrollBehavior = 'auto';
        row.scrollLeft = target;
        row.style.scrollBehavior = b;
        setTimeout(function () { settling = false; }, 0);
      }

      row.addEventListener('scroll', function () {
        if (settling) { return; }
        var maxSL = row.scrollWidth - row.clientWidth;
        /* Hard against an end: the browser has already clamped, so momentum
           is over and there is nothing left to wait for. Waiting anyway is
           what used to strand the row here - a late scroll event from the
           PREVIOUS wrap would keep clearing the settle timer, so it never
           fired and the strip stuck at the end with no card to its right. */
        if (row.scrollLeft <= 1 || row.scrollLeft >= maxSL - 1) {
          clearTimeout(timer);
          wrapNow();
          return;
        }
        /* Anywhere else, wait for scrolling to stop: moving scrollLeft
           mid-drag fights the browser's own momentum and shows as a stutter. */
        clearTimeout(timer);
        timer = setTimeout(wrapNow, 120);
      });

      /* A resize changes the viewport, so it can change how many copies a
         period needs. Rebuild rather than let the loop go out of range. */
      var rt = null;
      window.addEventListener('resize', function () {
        clearTimeout(rt);
        rt = setTimeout(function () { buildLoop(wrap); }, 200);
      });
    }
  }

  function bindRows(scope) {
    (scope || document).querySelectorAll('[data-dvp-rv]').forEach(buildLoop);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { bindRows(); });
  } else { bindRows(); }
  /* Images settle after load and can change the set width. */
  window.addEventListener('load', function () { bindRows(); });
  document.addEventListener('shopify:section:load', function (e) { bindRows(e.target); });

  /* Arrows move by one card plus its gap. */
  document.addEventListener('click', function (e) {
    var btn = closest(e.target, '[data-dvp-rv-prev], [data-dvp-rv-next]');
    if (!btn) { return; }
    var row = closest(btn, '[data-dvp-rv]').querySelector('[data-dvp-rv-row]');
    var card = row && row.querySelector('.dvp-rv-card');
    if (!row || !card) { return; }
    var step = card.getBoundingClientRect().width + (parseFloat(getComputedStyle(row).columnGap) || 0);
    row.scrollBy({ left: btn.hasAttribute('data-dvp-rv-prev') ? -step : step, behavior: 'smooth' });
  });

  /* ---- play a clip ------------------------------------------------------
     Swaps the thumbnail for the real player on first press and never again,
     so a visitor who scrolls past without watching downloads nothing. */
  document.addEventListener('click', function (e) {
    var btn = closest(e.target, '[data-dvp-rv-play]');
    if (!btn) { return; }

    var frame = closest(btn, '.dvp-rv-frame');
    var tpl = frame && frame.querySelector('[data-dvp-rv-embed]');
    if (!tpl) { return; }

    var poster = frame.querySelector('.dvp-rv-poster');
    var cap = frame.querySelector('.dvp-rv-cap');

    frame.appendChild(tpl.content.cloneNode(true));
    tpl.remove();
    btn.remove();
    if (poster) { poster.remove(); }
    if (cap) { cap.remove(); }

    var v = frame.querySelector('video');
    if (v) { v.play().catch(function () {}); }
  });
  /* ---- sticky buy bar ---------------------------------------------------
     Measures the bar so the page can leave room for it, reveals it once the
     buy box's own button has scrolled above the screen, and lifts the
     WhatsApp button only when the two would actually overlap. Reads layout on
     scroll but writes only when something changes. */
  function initBar() {
    var bar = document.querySelector('.dvp-bar[data-wb-bar]');
    var body = document.body;
    if (!bar) { body.classList.remove('wb-has-bar', 'wb-bar-lift'); return; }
    var section = closest(bar, '.wb-dvp');
    var main = section && section.querySelector('.dvp-add');
    var reveal = bar.hasAttribute('data-wb-bar-reveal');
    var state = '';

    function update() {
      var cs = getComputedStyle(bar);
      if (cs.display === 'none') {
        if (state !== 'off') { state = 'off'; body.classList.remove('wb-has-bar', 'wb-bar-lift'); }
        return;
      }
      var on = !reveal || !main || main.getBoundingClientRect().bottom < 0;
      var space = bar.offsetHeight + 2 * (parseFloat(cs.left) || 0);
      var lift = false;
      if (on) {
        var chat = document.querySelector('.wp-chat-button');
        if (chat) {
          var b = bar.getBoundingClientRect(), c = chat.getBoundingClientRect();
          lift = c.right > b.left && c.left < b.right;
        }
      }
      var next = (on ? 'on' : 'tucked') + (lift ? '-lift' : '') + space;
      if (next === state) { return; }
      state = next;
      body.style.setProperty('--wb-bar-space', space + 'px');
      body.classList.add('wb-has-bar');
      bar.classList.toggle('is-tucked', !on);
      body.classList.toggle('wb-bar-lift', lift);
    }

    update();
    if (!window.wbBarBound) {
      window.wbBarBound = true;
      window.addEventListener('scroll', function () { window.wbBarUpdate(); }, { passive: true });
      window.addEventListener('resize', function () { window.wbBarUpdate(); });
    }
    window.wbBarUpdate = update;
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBar);
  } else {
    initBar();
  }
  window.addEventListener('load', function () { if (window.wbBarUpdate) { window.wbBarUpdate(); } });
  document.addEventListener('shopify:section:load', initBar);
})();
